import { render, staticRenderFns } from "./InventoryCustomRoomOverlay.vue?vue&type=template&id=4e2763aa&"
import script from "./InventoryCustomRoomOverlay.vue?vue&type=script&lang=ts&"
export * from "./InventoryCustomRoomOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports